import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export const DeleteDialog = ({ show, onConfirm}) => {
  const [showModal, setShowModal] = useState(false);
  const [input, setInput] = useState('');

  const handleClose = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <Modal show={showModal ^ show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>If you are sure about to delete, please type "delete" here and confirm:</Form.Label>
            <Form.Control type="text" placeholder="delete"  name="input" value={input} onChange={(e) => setInput(e.target.value)}/>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" disabled={input!="delete"} onClick={ () => { onConfirm(); handleClose(); }}>Confirm</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
